/**
 * API usuarios internos del despacho — fachada /api/despacho/staff.
 */
import api from "@/lib/api";
import { DESPACHO_STAFF_FORBIDDEN_MESSAGE } from "@/modules/despacho/despachoPermissions";

export const DESPACHO_STAFF_API_PATH = "/despacho/staff";

export const LOAD_STAFF_ERROR_MESSAGE = "No pudimos cargar los usuarios internos del despacho.";

export function parseDespachoStaffError(err) {
  const status = err?.response?.status;
  const detail = err?.response?.data?.detail;

  if (status === 403) {
    const code = typeof detail === "object" && detail?.code;
    if (code === "MODULE_NOT_LICENSED" || code === "LICENSE_BLOCKED") {
      return { kind: "forbidden", message: "No tienes habilitado Gestión Despacho." };
    }
    if (code === "DESPACHO_STAFF_FORBIDDEN") {
      return { kind: "staff_forbidden", message: DESPACHO_STAFF_FORBIDDEN_MESSAGE };
    }
    return { kind: "forbidden", message: LOAD_STAFF_ERROR_MESSAGE };
  }

  if (status === 409) {
    const msg = typeof detail === "string" ? detail : "Ya existe un usuario con ese correo.";
    return { kind: "duplicate_email", message: msg };
  }

  if (status === 404) {
    return { kind: "not_found", message: "Usuario interno no encontrado." };
  }

  return { kind: "error", message: LOAD_STAFF_ERROR_MESSAGE };
}

export function createDespachoStaffApi(httpClient = api) {
  return {
    async list() {
      const { data } = await httpClient.get(DESPACHO_STAFF_API_PATH);
      return Array.isArray(data?.items) ? data.items : [];
    },

    async create(payload) {
      const { data } = await httpClient.post(DESPACHO_STAFF_API_PATH, payload);
      return data;
    },

    async update(staffId, payload) {
      const { data } = await httpClient.put(`${DESPACHO_STAFF_API_PATH}/${staffId}`, payload);
      return data;
    },

    async patchStatus(staffId, status) {
      const { data } = await httpClient.patch(`${DESPACHO_STAFF_API_PATH}/${staffId}/status`, { status });
      return data;
    },

    async remove(staffId) {
      await httpClient.delete(`${DESPACHO_STAFF_API_PATH}/${staffId}`);
    },
  };
}

export const despachoStaffApi = createDespachoStaffApi();
